import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { ProfilePopupComponent } from '../../profile-popup/profile-popup.component';
import { CommonModule } from '@angular/common';
import { NotificationPopupComponent } from '../../notification-popup/notification-popup.component';
import { ApiService } from '@app/services/api.service';
import { Subscription } from 'rxjs';
import { SnackbarService } from '@app/services/snackbar.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, ProfilePopupComponent, NotificationPopupComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  userInfo:any;
  isDropdownOpen = false;
  showNotificationPopup = false;
  showProfilePopup = false;
  showPricingModal = false;
  unreadCount: number = 0;
  showSubscriptionSuccess = false;
  showSubscriptionFailure = false;
  boosterSuccessMessage = false;
  subscriptionInfo: any = null;
  isAnnualBilling = false;
  plans: any[] = [];
  boosterTypes: any[] = [];
  planAddOns: any = {};
  selectedAddOnIds: any[] = [];
  subscriptionService: any = { info: null };
  private subscription = new Subscription();
  private destroy$ = new Subject<void>();
  private alertsInterval: any;





  constructor(
    private auth:AuthenticationService,
    private router:Router, 
    private apiService: ApiService,
    private snackbarService: SnackbarService){}

  ngOnInit(): void {
    this.userInfo = this.auth.currentUserValue;
    this.startAlertsPolling();
  }

  ngOnDestroy(): void {
    this.stopAlertsPolling();
    this.subscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  startAlertsPolling(): void {
    this.checkAlerts();
    this.alertsInterval = setInterval(() => {
      this.checkAlerts();
    }, 60000);
  }

  stopAlertsPolling(): void {
    if (this.alertsInterval) {
      clearInterval(this.alertsInterval);
      this.alertsInterval = null;
    }
  }

  checkAlerts(): void {
    this.apiService.getAlerts()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response) {
            this.unreadCount = response.unreadCount || 0;
            if (response.alert === true && response.alertMessage) {
              this.snackbarService.show('Notification', response.alertMessage, 'success', 5000);
            }
          }
        },
        error: (error) => {
          console.error('Error fetching alerts:', error);
        }
      });
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleNotificationPopup() {
    this.showNotificationPopup = !this.showNotificationPopup;
  }

  closeNotificationPopup() {
    this.showNotificationPopup = false;
  }

  handleNotificationAction(event: any) {
    if (event === 'close') {
      this.closeNotificationPopup();
    }
  }

  toggleProfilePopup() {
    this.showProfilePopup = !this.showProfilePopup;
    this.isDropdownOpen = false;
  }

  closeProfilePopup() {
    this.showProfilePopup = false;
  }

  handleProfileSubscribe() {
    this.closeProfilePopup();
  }

  closePricingModal(): void {
    this.showPricingModal = false;
  }

  viewReceipt(): void {
    // TODO: Implement view receipt functionality
  }

  toggleBilling(): void {
    this.isAnnualBilling = !this.isAnnualBilling;
  }

  getPlanPrice(plan: any): number {
    return this.isAnnualBilling ? (plan.annualPrice || plan.price * 12) : (plan.price || 0);
  }

  subscribe(plan: any): void {
    // TODO: Implement subscribe functionality
  }

  isButtonDisabled(plan: any): boolean {
    // TODO: Implement button disabled logic
    return false;
  }

  getPlanButtonText(plan: any): string {
    // TODO: Implement plan button text logic
    return 'Subscribe';
  }

  getBoosterTiers(): number[] {
    return [0, 1, 2];
  }

  getBoosterTypeLabel(type: string): string {
    // TODO: Implement booster type label logic
    return type;
  }

  onAddOnCheckboxChange(id: any, checked: boolean): void {
    // TODO: Implement add-on checkbox change logic
  }

  getChecked(event: any): boolean {
    return event.target.checked;
  }

  onAddPlanBooster(): void {
    // TODO: Implement add plan booster functionality
  }

  logout(){
    localStorage.removeItem('subscriptionWarningShown');
    this.subscription.add(
      this.auth.logout()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => this.router.navigate(['/sign-in']),
          error: (err) => {}
        })
    );
  }


}
